import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // Maintenance Schedules
  scheduleListing: {
    loading: false,
    error: null,
    data: null,
  },
  scheduleDetails: {
    loading: false,
    error: null,
    data: null,
  },
  overdueSchedules: {
    loading: false,
    error: null,
    data: null,
  },
  upcomingSchedules: {
    loading: false,
    error: null,
    data: null,
  },
  createSchedule: {
    loading: false,
    error: null,
    data: null,
  },
  updateSchedule: {
    loading: false,
    error: null,
    data: null,
  },
  // Maintenance Tasks
  taskListing: {
    loading: false,
    error: null,
    data: null,
  },
  taskDetails: {
    loading: false,
    error: null,
    data: null,
  },
  createTask: {
    loading: false,
    error: null,
    data: null,
  },
  updateTask: {
    loading: false,
    error: null,
    data: null,
  },
  // Dashboard & Calendar
  dashboard: {
    loading: false,
    error: null,
    data: null,
  },
  calendar: {
    loading: false,
    error: null,
    data: null,
  },
};

const maintenanceSlice = createSlice({
  name: "maintenance",
  initialState,
  reducers: {
    // Schedule Listing
    scheduleListingStart: (state) => {
      state.scheduleListing.loading = true;
      state.scheduleListing.error = null;
    },
    scheduleListingSuccess: (state, action) => {
      state.scheduleListing.loading = false;
      state.scheduleListing.data = action.payload;
      state.scheduleListing.error = null;
    },
    scheduleListingFailure: (state, action) => {
      state.scheduleListing.loading = false;
      state.scheduleListing.error = action.payload;
    },
    scheduleListingReset: (state) => {
      state.scheduleListing = initialState.scheduleListing;
    },

    // Schedule Details
    scheduleDetailsStart: (state) => {
      state.scheduleDetails.loading = true;
      state.scheduleDetails.error = null;
    },
    scheduleDetailsSuccess: (state, action) => {
      state.scheduleDetails.loading = false;
      state.scheduleDetails.data = action.payload;
      state.scheduleDetails.error = null;
    },
    scheduleDetailsFailure: (state, action) => {
      state.scheduleDetails.loading = false;
      state.scheduleDetails.error = action.payload;
    },
    scheduleDetailsReset: (state) => {
      state.scheduleDetails = initialState.scheduleDetails;
    },

    // Overdue Schedules
    overdueSchedulesStart: (state) => {
      state.overdueSchedules.loading = true;
      state.overdueSchedules.error = null;
    },
    overdueSchedulesSuccess: (state, action) => {
      state.overdueSchedules.loading = false;
      state.overdueSchedules.data = action.payload;
      state.overdueSchedules.error = null;
    },
    overdueSchedulesFailure: (state, action) => {
      state.overdueSchedules.loading = false;
      state.overdueSchedules.error = action.payload;
    },

    // Upcoming Schedules
    upcomingSchedulesStart: (state) => {
      state.upcomingSchedules.loading = true;
      state.upcomingSchedules.error = null;
    },
    upcomingSchedulesSuccess: (state, action) => {
      state.upcomingSchedules.loading = false;
      state.upcomingSchedules.data = action.payload;
      state.upcomingSchedules.error = null;
    },
    upcomingSchedulesFailure: (state, action) => {
      state.upcomingSchedules.loading = false;
      state.upcomingSchedules.error = action.payload;
    },

    // Create Schedule
    createScheduleStart: (state) => {
      state.createSchedule.loading = true;
      state.createSchedule.error = null;
      state.createSchedule.data = null;
    },
    createScheduleSuccess: (state, action) => {
      state.createSchedule.loading = false;
      state.createSchedule.data = action.payload;
      state.createSchedule.error = null;
    },
    createScheduleFailure: (state, action) => {
      state.createSchedule.loading = false;
      state.createSchedule.error = action.payload;
    },
    createScheduleReset: (state) => {
      state.createSchedule = initialState.createSchedule;
    },

    // Update Schedule
    updateScheduleStart: (state) => {
      state.updateSchedule.loading = true;
      state.updateSchedule.error = null;
      state.updateSchedule.data = null;
    },
    updateScheduleSuccess: (state, action) => {
      state.updateSchedule.loading = false;
      state.updateSchedule.data = action.payload;
      state.updateSchedule.error = null;
    },
    updateScheduleFailure: (state, action) => {
      state.updateSchedule.loading = false;
      state.updateSchedule.error = action.payload;
    },
    updateScheduleReset: (state) => {
      state.updateSchedule = initialState.updateSchedule;
    },

    // Task Listing
    taskListingStart: (state) => {
      state.taskListing.loading = true;
      state.taskListing.error = null;
    },
    taskListingSuccess: (state, action) => {
      state.taskListing.loading = false;
      state.taskListing.data = action.payload;
      state.taskListing.error = null;
    },
    taskListingFailure: (state, action) => {
      state.taskListing.loading = false;
      state.taskListing.error = action.payload;
    },
    taskListingReset: (state) => {
      state.taskListing = initialState.taskListing;
    },

    // Task Details
    taskDetailsStart: (state) => {
      state.taskDetails.loading = true;
      state.taskDetails.error = null;
    },
    taskDetailsSuccess: (state, action) => {
      state.taskDetails.loading = false;
      state.taskDetails.data = action.payload;
      state.taskDetails.error = null;
    },
    taskDetailsFailure: (state, action) => {
      state.taskDetails.loading = false;
      state.taskDetails.error = action.payload;
    },
    taskDetailsReset: (state) => {
      state.taskDetails = initialState.taskDetails;
    },

    // Create Task
    createTaskStart: (state) => {
      state.createTask.loading = true;
      state.createTask.error = null;
      state.createTask.data = null;
    },
    createTaskSuccess: (state, action) => {
      state.createTask.loading = false;
      state.createTask.data = action.payload;
      state.createTask.error = null;
    },
    createTaskFailure: (state, action) => {
      state.createTask.loading = false;
      state.createTask.error = action.payload;
    },
    createTaskReset: (state) => {
      state.createTask = initialState.createTask;
    },

    // Update Task
    updateTaskStart: (state) => {
      state.updateTask.loading = true;
      state.updateTask.error = null;
      state.updateTask.data = null;
    },
    updateTaskSuccess: (state, action) => {
      state.updateTask.loading = false;
      state.updateTask.data = action.payload;
      state.updateTask.error = null;
    },
    updateTaskFailure: (state, action) => {
      state.updateTask.loading = false;
      state.updateTask.error = action.payload;
    },
    updateTaskReset: (state) => {
      state.updateTask = initialState.updateTask;
    },

    // Dashboard
    dashboardStart: (state) => {
      state.dashboard.loading = true;
      state.dashboard.error = null;
    },
    dashboardSuccess: (state, action) => {
      state.dashboard.loading = false;
      state.dashboard.data = action.payload;
      state.dashboard.error = null;
    },
    dashboardFailure: (state, action) => {
      state.dashboard.loading = false;
      state.dashboard.error = action.payload;
    },
    dashboardReset: (state) => {
      state.dashboard = initialState.dashboard;
    },

    // Calendar
    calendarStart: (state) => {
      state.calendar.loading = true;
      state.calendar.error = null;
    },
    calendarSuccess: (state, action) => {
      state.calendar.loading = false;
      state.calendar.data = action.payload;
      state.calendar.error = null;
    },
    calendarFailure: (state, action) => {
      state.calendar.loading = false;
      state.calendar.error = action.payload;
    },
  },
});

export const {
  scheduleListingStart,
  scheduleListingSuccess,
  scheduleListingFailure,
  scheduleListingReset,
  scheduleDetailsStart,
  scheduleDetailsSuccess,
  scheduleDetailsFailure,
  scheduleDetailsReset,
  overdueSchedulesStart,
  overdueSchedulesSuccess,
  overdueSchedulesFailure,
  upcomingSchedulesStart,
  upcomingSchedulesSuccess,
  upcomingSchedulesFailure,
  createScheduleStart,
  createScheduleSuccess,
  createScheduleFailure,
  createScheduleReset,
  updateScheduleStart,
  updateScheduleSuccess,
  updateScheduleFailure,
  updateScheduleReset,
  taskListingStart,
  taskListingSuccess,
  taskListingFailure,
  taskListingReset,
  taskDetailsStart,
  taskDetailsSuccess,
  taskDetailsFailure,
  taskDetailsReset,
  createTaskStart,
  createTaskSuccess,
  createTaskFailure,
  createTaskReset,
  updateTaskStart,
  updateTaskSuccess,
  updateTaskFailure,
  updateTaskReset,
  dashboardStart,
  dashboardSuccess,
  dashboardFailure,
  dashboardReset,
  calendarStart,
  calendarSuccess,
  calendarFailure,
} = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
